export default __webpack_public_path__ + "static/media/Lexend-Medium.00d5c1dc.ttf";